import { identity } from "@workspace/mobile";
import { getEnvironmentProps, isDmnURL } from "./environment";

/**
 * Wrapper for the identity service
 */
export const dmnIdentity = {
  isAccessIdentityEnabled: false,
  signOut: () => {
    if (isDmnURL()) {
      const environmentVars = getEnvironmentProps("");
      // Desktop sign out
      window.location.assign(
        `${environmentVars?.BROWSER_SIGN_OUT_URL}&appName=Collins&returnUrl=${environmentVars?.BROWSER_SIGN_IN_URL}`
      );
      return;
    }

    // Mobile sign out
    identity.signOut();
  },
  getAccessToken: async (): Promise<string> => {
    const token = await (isDmnURL()
      ? dmnIdentity.getDMNAccessToken()
      : dmnIdentity.getIdentityAccessToken());

    if (!token) {
      dmnIdentity.signInRedirect();
      return "";
    }

    return token;
  },

  getIdentityAccessToken: async () => {
    // Identity SDK will handle redirect, storing current URL to be handled in ./callback.html
    window.sessionStorage.setItem(
      "collins:postSignInRedirect",
      JSON.stringify({ url: window.location.href })
    );

    return await identity.getAccessToken();
  },

  getDMNAccessToken: async () => {
    const cookie = dmnIdentity.getDMNAuthCookie();
    const token = cookie ? `${JSON.parse(cookie)?.access_token}` : "";
    return token;
  },
  signInRedirect: () => {
    if (isDmnURL()) {
      const environmentVars = getEnvironmentProps("");

      window.location.assign(
        `${environmentVars.BROWSER_SIGN_IN_URL}?returnUrl=${encodeURIComponent(window.location.href)}`
      );
      return;
    }
  },
  getDMNAuthCookie: () => {
    const cookieNames = ["dev_AccessToken", "qa_AccessToken", "AccessToken"];
    const cookies = document.cookie.split("; ");

    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (cookieNames.includes(name)) {
        return value;
      }
    }

    return null;
  },
  getDMNImpersonateeAuthCookie: () => {
    const cookies = document.cookie.split("; ");

    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === "ImpersonateeAccessToken") {
        return value;
      }
    }

    return null;
  },
  getDMNImpersonateeAccessToken: () => {
    const cookie = dmnIdentity.getDMNImpersonateeAuthCookie();
    return cookie ? `${JSON.parse(cookie)?.access_token}` : "";
  },
  getImpersonateeIdCookie: () => {
    const cookies = document.cookie.split("; ");

    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === "impersonate_id") {
        return value;
      }
    }

    return null;
  },
  getDMNImpersonateeID: () => {
    const cookie = dmnIdentity.getImpersonateeIdCookie();
    return cookie ? `${JSON.parse(cookie)}` : "";
  }
};
